/* eslint-disable import/prefer-default-export */
import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';
import { ERROR_MESSAGE } from '../lib/constants';
import store from '../store';

const token = localStorage.getItem('jwtToken') || null;

const getBody = (actionType, description) => {
  return {
    actions: [
      {
        description,
        actionType,
      },
    ],
  };
};

export const addAction = description => {
  const body = getBody('Add', description);
  //return Log box sesssion
  return logBoxSession(body);
};

export const disableAction = description => {
  const body = getBody('Disable', description);
  //return Log box sesssion
  return logBoxSession(body);
};

export const enableAction = description => {
  const body = getBody('Enable', description);
  //return Log box sesssion
  return logBoxSession(body);
};

export const changeAction = description => {
  const body = getBody('Change', description);
  //return Log box sesssion
  return logBoxSession(body);
};
export const deleteAction = description => {
  const body = getBody('Delete', description);
  //return Log box sesssion
  return logBoxSession(body);
};

export const createAction = description => {
  const body = getBody('Create', description);
  //return Log box sesssion
  return logBoxSession(body);
};

export const assignAction = description => {
  const body = getBody('Assign', description);
  //return Log box sesssion
  return logBoxSession(body);
};

export const unassignAction = description => {
  const body = getBody('Unassign', description);
  //return Log box sesssion
  return logBoxSession(body);
};

//util api boxes function
const logBoxSession = body => async dispatch => {
  const boxId = store.getState()?.AppState?.boxDetails?.box._id;
  const api = new Api(token);
  try {
    const data = await api.boxes.logBoxSession(body, boxId);
    dispatch(resetBulkBoxSession());
    return data;
  } catch (error) {
    dispatch({
      type: 'LOG_ACTION_ERROR',
      error,
    });
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'LOG_ACTION_ERROR',
    });
  }
};

//bulk box session body
const getBulkBoxSessionBody = (actionType, description, key) => ({
  actionType,
  description,
  key,
});
//add bulk box session
export const addBulkBoxSession = (description, key) => async dispatch => {
  const payload = getBulkBoxSessionBody('Add', description, key);
  console.log('body', description, key);
  //dispatch
  dispatch({
    type: 'BULK_BOX_SESSION',
    payload,
  });
};

//dispatch bulk Box Session to update
export const changeBulkBoxSession = (description, key) => async dispatch => {
  const payload = getBulkBoxSessionBody('Change', description, key);
  //dispatch
  dispatch({
    type: 'BULK_BOX_SESSION',
    payload,
  });
};

//dispatch bulk Box Session to enable
export const enableBulkBoxSession = (description, key) => async dispatch => {
  const payload = getBulkBoxSessionBody('Enable', description, key);
  // console.log('body', description, key);
  //dispatch
  dispatch({
    type: 'BULK_BOX_SESSION',
    payload,
  });
};
//dispatch bulk Box Session to disable
export const disableBulkBoxSession = (description, key) => async dispatch => {
  const payload = getBulkBoxSessionBody('disable', description, key);
  // console.log('body', description, key);
  //dispatch
  dispatch({
    type: 'BULK_BOX_SESSION',
    payload,
  });
};

//dispatch bulk Box Session to Reset to default value []
export const resetBulkBoxSession = () => async dispatch => {
  dispatch({
    type: 'BULK_BOX_SESSION_RESET',
  });
};

export const advModemConfig = value => async dispatch => {
  dispatch({
    type: 'ADV_MODEM_CONFIG',
    value,
  });
};

export const callerIdOverride = value => async dispatch => {
  dispatch({
    type: 'CALLER_ID_OVERRIDE',
    value,
  });
};

export const blockCallerIdConfig = value => async dispatch => {
  dispatch({
    type: 'BLOCK_CALLER_ID',
    value,
  });
};

export const getAllLogs = (token, pagination, filters) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.systemLogBox(pagination, filters);
    dispatch({
      type: 'GET_ALL_LOGS',
      payload: data,
    });
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_ALL_LOGS',
    });
  }
};

export const sendBulkActionsToApi = () => {
  const bulkBoxSessions = store.getState()?.AppState?.boxDetails?.bulkBoxSession;

  //removing keys from objects
  bulkBoxSessions.forEach(async item => {
    delete item['key'];
  });
  //final body to send
  const body = {
    actions: bulkBoxSessions,
  };
  //return Log box sesssion
  return logBoxSession(body);
};
